import { Routes } from "@angular/router";
import { PagesComponent } from "./pages.component";
import { ProducersComponent } from "./producers/producers.component";
import { GiftCardsComponent } from "./gift-cards/gift-cards.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { howItWorksRoutes } from "./how-it-works/how-it-works.routes";
import { aboutUsRoutes } from "./about-us/about-us.routes";
import { faqRoutes } from "./faq/faq.routes";
import { ProducerDetailComponent } from "./producers/producer-detail/producer-detail.component";
import { maintenanceGuard } from "../shared/guards/auth-guard.guard";
import { BlogComponent } from "./blog/blog.component";
import { BlogPostComponent } from "./blog/blog-post/blog-post.component";

export const pagesRoutes: Routes = [
  {
    path: 'pages',
    title: 'Pages',
    component: PagesComponent,
    canActivate: [maintenanceGuard],
    canActivateChild: [maintenanceGuard],
    children: [
      ...howItWorksRoutes,
      ...aboutUsRoutes,
      ...faqRoutes,
      {
        path: 'producers',
        title: 'Producers',
        component: ProducersComponent
      },
      {
        path: 'producers/:producerUrl',
        title: 'Producer Detail',
        component: ProducerDetailComponent
      },
      {
        path: 'gift-cards',
        title: 'Gift cards',
        component: GiftCardsComponent
      },
      {
        path: 'contact-us',
        title: 'Contact Us',
        component: ContactUsComponent
      },
      {
        path: 'blog',
        title: 'Blog',
        component: BlogComponent
      },
      {
        path: 'blog-post/:category/:title',
        title: 'Blog Post',
        component: BlogPostComponent
      },
    ]
  },
];
